// NOTE: these keys come from the env_script_tag list in
// app/views/layouts/works.html.erb; a key missing there is undefined at runtime.
type EnvVarType = {
  APP_NAME?: string;
  APP_VERSION?: string;
  RAILS_ENV?: string;
  SENTRY_APP_NAME?: string;
  SENTRY_DSN?: string;
  SENTRY_ENV?: string;
  SENTRY_GRAPHQL_METRICS_PERCENT?: string;
  SENTRY_REPLAY_ENABLED?: string;
  WORKS_INTERCOM_APP_ID?: string;
};

type WindowType = Window & {
  __ENV__: EnvVarType;
};

export const ENV_VARS = (window as unknown as WindowType).__ENV__ || {};
